import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import { Chip } from '@mui/material';
import BasicFilterDropdown from '../BasicFilterDropdown/BasicFilterDropdown';
import BasicDropdownOption from '../BasicDropdownOption/BasicDropdownOption';
import { useWindowSize } from '../../../../../../utils/hooks';
import colors from '../../../../../../scss/colors';
import classes from './ClaimFilter.module.scss';
import { responsiveSizeTimesheet } from '../../../../../../utils/constants';

const StyledInput = styled(InputBase)(({ theme }) => ({
  padding: '20px 20px 28px 20px',
  width: '100%',
  '& input': {
    borderRadius: 10,
    backgroundColor: colors.WHITE,
    padding: '14px 14px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    border: `1px solid ${colors.LIGHT_GREY}`,
    fontSize: 14
  }
}));

export default function ClaimFilter({ claims = [], selectedClaim, changeClaim, dateBackAction }) {
  const { t } = useTranslation();
  const { width } = useWindowSize();

  const [open, setOpen] = useState(false);
  const [text, setText] = useState('');

  const handleFilterToggle = () => {
    setOpen(!open);
    dateBackAction('', selectedClaim, '');
  };

  return (
    <BasicFilterDropdown
      type={t('dashboard.expenses.filters.claim')}
      text={t('dashboard.expenses.filters.claim')}
      active={selectedClaim && selectedClaim !== t('common.general.all')}
      open={open}
      setOpen={handleFilterToggle}
      extraHeader={{
        enabled: !!selectedClaim,
        label: t('common.filters.reset'),
        action: () => {
          changeClaim('');
          setText('');
          setOpen(false);
        }
      }}
    >
      <div className={classes.container}>
        <StyledInput
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder={t('dashboard.expenses.filters.addclaimname')}
        />
        {width > responsiveSizeTimesheet && (
          <BasicDropdownOption
            key={t('common.general.all')}
            text={t('common.general.all')}
            selected={!selectedClaim}
            clickHandler={() => {
              changeClaim('');
              setText('');
              setOpen(false);
            }}
          />
        )}
        <div className={classes.listContainer}>
          {width <= responsiveSizeTimesheet && (
            <Chip
              variant={!selectedClaim ? 'filled' : 'outlined'}
              key={selectedClaim}
              label={t('common.general.all')}
              onClick={() => {
                changeClaim('');
                setText('');
                setOpen(false);
              }}
              sx={{
                '&.MuiChip-root': {
                  backgroundColor: !selectedClaim ? colors.NAVY_BLUE : colors.PAGE_BACKGROUND,
                  color: !selectedClaim ? colors.WHITE : colors.MEDIUM_GREY,
                  fontStyle: 'normal',
                  fontWeight: '500',
                  fontSize: '16px',
                  lineHeight: '19px'
                }
              }}
            />
          )}
          {claims
            .filter((item) => (text ? item.toLowerCase().includes(text.toLowerCase()) : true))
            .map((claim) =>
              width > responsiveSizeTimesheet ? (
                <BasicDropdownOption
                  key={claim}
                  text={claim || t('common.general.all')}
                  selected={JSON.stringify(selectedClaim) === JSON.stringify(claim)}
                  clickHandler={() => {
                    changeClaim(claim || { FirstName: '', LastName: '' });
                    setOpen(false);
                  }}
                />
              ) : (
                <Chip
                  variant={JSON.stringify(selectedClaim) === JSON.stringify(claim) ? 'filled' : 'outlined'}
                  key={claim}
                  label={claim || t('common.general.all')}
                  onClick={() => {
                    changeClaim(claim || '');
                    setOpen(false);
                  }}
                  sx={{
                    '&.MuiChip-root': {
                      maxWidth: '160px',
                      backgroundColor:
                        JSON.stringify(selectedClaim) === JSON.stringify(claim)
                          ? colors.NAVY_BLUE
                          : colors.PAGE_BACKGROUND,
                      color:
                        JSON.stringify(selectedClaim) === JSON.stringify(claim) ? colors.WHITE : colors.MEDIUM_GREY,
                      fontStyle: 'normal',
                      fontWeight: '500',
                      fontSize: '16px',
                      lineHeight: '19px'
                    }
                  }}
                />
              )
            )}
        </div>
      </div>
    </BasicFilterDropdown>
  );
}
